import { memo } from 'react';

import WidgetStatePlaceholder from '../../components/WidgetStatePlaceholder';
import { useWidgetStateCopy } from '../../context/WidgetStateCopyContext.jsx';

/**
 * What a widget draws when the result it was handed holds nothing it can plot
 * (CT-5641).
 *
 * Every catalogue widget guards its own required fields, and the guard used
 * to `return null`. On a dashboard, in the library's detail panel and in the
 * builder's live preview that reads as a **blank card**: the title bar with
 * an empty body, which looks like the widget is broken rather than like the
 * query came back without the number the drawing needs.
 *
 * It is not the same state as `status: EMPTY`. There the engine said it found
 * nothing and `toWidgetData` hands down `null`, so `CatalogWidget` never
 * reaches the component. This is the other one: a `READY` result whose shape
 * is right and whose plotted values are absent — a `SUM` over a column where
 * every row is null, which is exactly what dev answers today for
 * `INDICATOR` and `CORRELATION`. The reader is owed the same sentence either
 * way.
 *
 * Deliberately the same copy and the same component `CatalogWidget` falls
 * back to, so "there is nothing here" looks identical wherever it is decided.
 */
const WidgetNothingToDraw = memo(function WidgetNothingToDraw() {
  const stateCopy = useWidgetStateCopy();
  return <WidgetStatePlaceholder isEmpty stateCopy={stateCopy} />;
});

export default WidgetNothingToDraw;
